import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const citizenServicesCategoryField =`
id
channelUniqueId
channelName
`;



export const GET_CITIZEN_SERVICES_DELIVERY_CHANNEL = gql`
query CitizenGetServicesDeliveryChannels($serviceUniqueId:String){
    citizenGetServicesDeliveryChannels(serviceUniqueId:$serviceUniqueId){
    ${baseResponseGraphqlField}
    data {
      ${citizenServicesCategoryField}
    }
  }
}
`
;
